import { Directive, Input, computed, inject } from '@angular/core';

import { BetslipConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { Store, createSelector } from '@ngrx/store';

import { BetslipPick } from '../../../core/picks/betslip-pick';
import { RemoveButtonStyle } from '../../picks/components/digital/pick-remove-button/remove-button-style';
import { selectSingleBetPicks } from '../../types/selectors';
import { RemoveButtonPosition } from '../remove-button-position-enum';
import { isMultiSingleBetSelector, singleBetStateSelector } from '../selectors';
import { ISingleBetPickState, ISingleBetState } from '../state';

export const selectSingleBetComponentState = createSelector(
    singleBetStateSelector,
    isMultiSingleBetSelector,
    selectSingleBetPicks,
    (singleBetState, multiSingleBet, pickList) => ({ singleBetState, multiSingleBet, pickList }),
);

@Directive({
    host: {
        '[class.betslip-digital-bet-pick--has-stake-input]': 'alwaysShowStakeInput || isMultiSingleBet()',
    },
    standalone: false,
})
export abstract class BaseSingleBetComponent {
    private readonly store = inject(Store);
    private state = this.store.selectSignal(selectSingleBetComponentState, {
        equal: (a, b) => {
            return a.multiSingleBet === b.multiSingleBet && a.pickList === b.pickList && a.singleBetState.picks === b.singleBetState.picks;
        },
    });

    @Input() oddsDisplayFormat: OddsDisplayFormat;
    @Input() removeButtonPosition: RemoveButtonPosition;
    @Input() removeButtonStyle: RemoveButtonStyle;

    isMultiSingleBet = computed(() => this.state().multiSingleBet);

    viewModel = computed(() => ({
        singleBetState: this.state().singleBetState,
        pickList: this.state().pickList,
        pickCount: Object.values(this.state().singleBetState.picks).filter((p) => p.isSelected).length,
    }));

    protected get alwaysShowStakeInput() {
        return false;
    }

    protected constructor(
        public betslipConfig: BetslipConfig,
        public sitecore: Sitecore,
    ) {}

    pickTrackBy(index: number, pick: BetslipPick): string {
        return pick.id.toString();
    }

    singleBetPick(singleBet: ISingleBetState, pick: BetslipPick): ISingleBetPickState {
        return singleBet.picks[pick.id.toString()];
    }
}
